<template>
    <section class="reports-dashboard">
        <h2 data-qa="reports-heading">
            {{ reportTitle ? reportTitle : 'Reports' }}
        </h2>

        <div class="pinned-text">
            <img src="/resources/funnel/images/svg/pin-icon.svg" alt="pin-image" />
            <span data-qa="pinned-text">Pinned</span>
        </div>

        <template v-if="isHasPinnedReports">
            <div style="display: grid; grid-row-gap: 1rem; grid-column-gap: 1rem; grid-template-columns: repeat(5, 1fr);padding-top: 10px;">
                <ds-card
                    v-for="(item, index) in pinnedReportsData"
                    :key="index"
                    elevation="z4"
                    data-qa="pinned-reports"
                >
                    <ds-card-body>
                        <div class="report-item-header">
                            <div class="report-title" :title="`${item.name}`" data-qa="report-title">
                                {{ reportName(item.name) }}
                            </div>

                            <ds-dropdown class="dropdown">
                                <ds-icon-button class="icon-only">
                                    <ds-icon name="more-vertical" />
                                </ds-icon-button>

                                <div slot="menu">
                                    <ul class="dropdown-menu-list">
                                        <li
                                            class="dropdown-menu-item pin-to-top"
                                            data-qa="pin-to-top-unpin-reports"
                                            @click="unpinReports(item.name)"
                                        >
                                            <img src="/resources/funnel/images/svg/pin-icon.svg" alt="pin-image" />
                                            <span data-qa="unpin">Unpin</span>
                                        </li>
                                    </ul>
                                </div>
                            </ds-dropdown>
                        </div>

                        <div class="reports-item-description" :title="`${item.description ? item.description : item.reportTemplate}`" data-qa="reports-item-description">
                            {{ reportDescription(item.description ? item.description : item.reportTemplate) }}
                        </div>
                    </ds-card-body>

                    <ds-card-footer class="report-item-footer" data-qa="report-item-footer">
                        <ds-tooltip wrap>
                            <template #reference>
                                <ds-icon name="info-circle" />
                            </template>

                            <template #default>
                                <div v-if="item.keapReport" data-qa="keap-report">
                                    Report created by Keap
                                </div>

                                <div v-else data-qa="saved-search-cloned">
                                    Saved search cloned from "{{ item.reportTemplate }}" by {{ item.createdBy }} on {{ dateFormatDate(item.dateCreated, 'MMM D, YYYY, h:mm a') }} MST
                                </div>
                            </template>
                        </ds-tooltip>

                        <ds-tooltip position="top">
                            <template #reference>
                                <div @click="openReport(item)">
                                    <ds-icon name="arrow-long-right" />
                                </div>
                            </template>

                            <template #default>
                                View report
                            </template>
                        </ds-tooltip>
                    </ds-card-footer>
                </ds-card>
            </div>
        </template>

        <div v-else class="no-reports-data" data-qa="no-reports-data">
            <h2>
                Pin your favorite reports here
            </h2>

            <p>
                Get quick access to your most used reports or saved searches, just select "Pin to top" in the more menu of the report or saved search.
            </p>
        </div>
    </section>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        pinnedReportsData: Array,
        reportTitle: String,
    },

    computed: {
        isHasPinnedReports() {
            return Boolean(this.pinnedReportsData?.length);
        },
    },

    methods: {
        dateFormatDate(date, format = 'll') {
            return moment(date).isValid() ? moment(date).format(format) : '';
        },

        openReport(report) {
            this.$emit('openReport', report.uri);
        },

        unpinReports(reportName) {
            this.$emit('unpinReports', reportName);
        },

        reportName(name) {
            return name.length > 40 ? `${name.substring(0, 40)} ...` : name;
        },

        reportDescription(desc) {
            return desc.length > 120 ? `${desc.substring(0, 120)} ...` : desc;
        },
    },
};
</script>

<style lang="scss">
    .tooltip {
        --tooltip-width: #{px-to-rem(300px)};
    }
</style>

<style lang="scss" scoped>
.reports-dashboard{
    .ds-card {
        padding: $spacing-100;
    }

    .ds-card-body {
        padding: $spacing-100 0;
        min-height: 8.25rem;
    }

    .pinned-text {
        margin: $spacing-300 0 $spacing-100;
        display: flex;
        align-items: center;
        span {
            margin-left: $spacing-100;
            font-size: $font-size-sm;
            font-weight: $font-weight-bold;
        }
    }

    .report-title {
        font-size: $font-size-xs;
        font-weight: $font-weight-semibold;
        margin-bottom: $spacing-100;
    }

    .reports-item-description {
        font-size: $font-size-xs;
        word-break: break-word;
    }

    .report-item-header {
        display: flex;
        justify-content: space-between;
        button {
          padding: 0;
          margin-left: .3rem;
        }
    }
    .report-item-footer {
        display: flex;
        justify-content: space-between;
        padding: 0;
        border-top: 0;
        .icon {
            height: 1rem;
            min-height: 1rem;
        }
    }

    .no-reports-data {
        padding: $spacing-400 0;
        text-align: center;
        p {
            width: 39%;
            margin: 0 auto;
        }
        h2 {
            font-weight: $font-weight-semibold;
            margin-bottom: $spacing-200;
        }
    }

    .pin-to-top span {
        margin-left: $spacing-200;
    }
}
</style>
